import { render } from "./PathNotFound.vue?vue&type=template&id=514da36f"
import script from "./PathNotFound.vue?vue&type=script&lang=js"
export * from "./PathNotFound.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/solution/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__